import { NavigationItem } from '@toolpad/core';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import IngredientIcon from '@mui/icons-material/Liquor';
import ListIcon from '@mui/icons-material/List';
import AlcoholIcon from '@mui/icons-material/LocalBar';
import LocalDrinkIcon from '@mui/icons-material/LocalDrink';
import MailIcon from '@mui/icons-material/Mail';
import UsersIcon from '@mui/icons-material/People';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import TabsIcon from '@mui/icons-material/Receipt';
import OrdersIcon from '@mui/icons-material/ReceiptLong';

import { CustomNavigationPageItem } from '../../App/Layout';

export const NAVIGATION: (NavigationItem | CustomNavigationPageItem)[] = [
    {
        // kind: 'divider',
        title: 'BusinessSelector',
    },
    {
        title: 'Dashboard',
        kind: 'page',
        icon: <DashboardIcon />,
    },
    {
        segment: 'orders',
        title: 'Orders',
        icon: <OrdersIcon />,
        pattern: 'orders{/:id}*',
    },
    {
        segment: 'reports',
        title: 'Reports',
        icon: <TabsIcon />,
        children: [
            {
                segment: 'sales',
                title: 'Sales',
            },
            {
                segment: 'inventory',
                title: 'Inventory',
            },
        ],
    },
    {
        kind: 'divider',
    },
    {
        segment: 'users',
        title: 'Users',
        icon: <UsersIcon />,
        pattern: 'users{/:id}*',
    },
    {
        segment: 'customers',
        title: 'Customers',
        icon: <UsersIcon />,
        userTypes: ['Internal'],
        pattern: 'customers{/:id}*',
    },
    {
        segment: 'places',
        title: 'Places',
        icon: <PlaceOutlinedIcon />,
        pattern: 'places{/:id}*',
    },
    {
        segment: 'businesses',
        title: 'Businesses',
        icon: <BusinessOutlinedIcon />,
        pattern: 'businesses{/:id}*',
    },
    {
        kind: 'header',
        title: 'Base Menu',
    },
    // {
    //     kind: 'divider',
    // },

    {
        segment: 'core',
        title: 'Core',
        icon: <LocalDrinkIcon />,
        userTypes: ['Internal'],
        children: [
            {
                segment: 'categories',
                title: 'Categories',
                pattern: 'categories{/:id}*',
            },
            {
                segment: 'ingredients',
                title: 'Ingredients',
                pattern: 'ingredients{/:id}*',
            },
            {
                segment: 'price-tiers',
                title: 'Price Tiers',
                pattern: 'price-tiers{/:id}*',
            },
            {
                segment: 'substitutions',
                title: 'Substitutions',
                pattern: 'substitutions{/:id}*',
            },
            {
                segment: 'pour-types',
                title: 'Pour Types',
                pattern: 'pour-types{/:id}*',
            },
            {
                segment: 'pour-formats',
                title: 'Pour Formats',
                pattern: 'pour-formats{/:id}*',
            },
            {
                segment: 'packaging-formats',
                title: 'Packaging Formats',
                pattern: 'packaging-formats{/:id}*',
            },
            {
                segment: 'serving-containers',
                title: 'Serving Containers',
                pattern: 'serving-containers{/:id}*',
            },
        ],
    },
    {
        segment: 'products',
        title: 'Products',
        icon: <IngredientIcon />,
        userTypes: ['Internal'],
        children: [
            {
                title: 'Products',
                pattern: 'products{/:id}*',
            },
            {
                segment: 'product-lines',
                title: 'Product Lines',
                pattern: 'product-lines{/:id}*',
            },
            {
                segment: 'brands',
                title: 'Brands',
                pattern: 'brands{/:id}*',
            },
            {
                segment: 'categories',
                title: 'Categories',
                pattern: 'categories/{:id}?',
            },
            {
                segment: 'types',
                title: 'Types',
                pattern: 'types{/:id}*',
            },
            {
                segment: 'subtypes',
                title: 'Subtypes',
                pattern: 'subtypes{/:id}*',
            },
            // {
            //     segment: 'attributes',
            //     title: 'Attributes',
            //     pattern: 'attributes{/:id}*',
            // },
        ],
    },
    {
        segment: 'master-menu',
        title: 'Master Menu',
        icon: <AlcoholIcon />,
        userTypes: ['Internal'],
        children: [
            {
                segment: 'standard-drinks',
                title: 'Standard Drinks',
                pattern: 'standard-drinks{/:id}*',
            },
            {
                segment: 'pour-availability',
                title: 'Pour Availability',
                pattern: 'pour-availability{/:id}*',
            },
        ],
    },
    {
        segment: 'business-menu',
        title: 'Business Menu',
        icon: <ListIcon />,
        userTypes: ['Internal', 'Business'],
        children: [
            {
                segment: 'menu-items',
                title: 'Menu Items',
                pattern: 'menu-items{/:id}*',
            },
            {
                segment: 'custom-drinks',
                title: 'Custom Drinks',
                pattern: 'custom-drinks{/:id}*',
            },
            {
                segment: 'pour-availability',
                title: 'Pour Availability',
                pattern: 'pour-availability{/:id}*',
            },
            {
                segment: 'categories',
                title: 'Categories',
                pattern: 'categories{/:id}*',
            },
            {
                segment: 'default-products',
                title: 'Default Products',
                pattern: 'default-products{/:id}*',
            },
            {
                segment: 'price-tiers',
                title: 'Price Tiers',
                pattern: 'price-tiers{/:id}*',
            },
            {
                segment: 'product-price-tiers',
                title: 'Product Price Tiers',
                pattern: 'product-price-tiers{/:id}*',
            },
            {
                segment: 'serving-containers',
                title: 'Serving Containers',
                pattern: 'serving-containers{/:id}*',
            },
        ],
    },
    {
        kind: 'divider',
    },

    {
        segment: 'signups',
        title: 'Signups',
        icon: <MailIcon />,
        userTypes: ['Internal'],
    },
];
